import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text, SkeletonLoader } from '@grandvisionhq/elements';
import { Address } from '@grandvisionhq/locations';
import { useIntl } from '@grandvisionhq/state';
import { AppointmentConfirmationTime } from '../AppointmentConfirmationTime/AppointmentConfirmationTime.js';

const AppointmentOverview = (_param)=>{
    var { appointment , className , labels , addressData , children , isStoreLoading =false  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointment",
        "className",
        "labels",
        "addressData",
        "children",
        "isStoreLoading"
    ]);
    const { getLabel  } = useIntl();
    const { invitee , child , appointmentType , startTime , endTime  } = appointment;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-overview', className)
    }), invitee && /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: "appointment-overview__body-head"
    }, invitee.firstName, " ", invitee.lastName), child && /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: "appointment-overview__body-head"
    }, labels.child, ": ", child.firstName, " ", child.lastName), /*#__PURE__*/ React.createElement(AppointmentConfirmationTime, {
        startTime: startTime,
        endTime: endTime,
        appointmentType: appointmentType
    }), isStoreLoading ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__store"
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "60px",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "20px",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "50%",
        height: "20px",
        rx: "5",
        fill: "currentColor",
        y: "30"
    })))) : addressData && /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__store"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: "appointment-overview__body-head"
    }, addressData.storeName), /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__store-address"
    }, /*#__PURE__*/ React.createElement(Address, {
        data: addressData
    }))), labels.additionalInformation && appointment.customerComment ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-overview__additional-information"
    }, labels.additionalInformation, appointment.customerComment) : null, children);
};

export { AppointmentOverview as default };
//# sourceMappingURL=AppointmentOverview.js.map
